import React, { Fragment } from "react";
import Container from "@mui/material/Container";
import Header from "../Header";
import FooterBar from "../FooterBar";
import {
  createTheme,
  ThemeProvider,
  responsiveFontSizes,
} from "@mui/material/styles";

let theme = createTheme();

theme = responsiveFontSizes(theme);

const CommonLayout = (props: any) => {
  const showFooter = props.footer;

  return (
    <Fragment>
      <Header
        headernavigation={props.showHeaderNavigation}
        isLogedIn={props.isLogedIn}
        cellmaflexUrl = {props.cellmaflexUrl}
      />
      <ThemeProvider theme={theme}>
        <Container
          maxWidth="lg"
          sx={{
            marginBottom: theme.spacing(10),
            marginTop: { xs: "130px", sm: "96px", md: "96px" },
          }}
        >
          {props.children}
        </Container>
      </ThemeProvider>
      {showFooter && <FooterBar />}
    </Fragment>
  );
};

export default CommonLayout;
